import {Button, Typography} from '@logistics-frontend/blocks'
import {useFormValue} from '@logistics-frontend/form/v2'
import clsx from 'clsx'
import {useCallback} from 'react'

import {PollQuestion, PollQuestionAnswer} from 'src/api/cargo-c2c'

import {classes} from './Answer.classes'
import {FormType} from './Form.types'

export type AnswerProps = {
  answer: PollQuestionAnswer
  handleAnswerClick: (question: PollQuestion, answer: PollQuestionAnswer) => void
  question: PollQuestion
}

export function Answer({answer, handleAnswerClick, question}: AnswerProps): React.ReactElement<AnswerProps> {
  const onAnswerClick = useCallback(() => {
    handleAnswerClick(question, answer)
  }, [answer, handleAnswerClick, question])

  const isAnswerSelected = (useFormValue<FormType, string>(question.id) || []).some(value => value === answer.id)

  return (
    <Button
      className={clsx(isAnswerSelected && classes.selected)}
      onPress={onAnswerClick}
      px="s"
      size="xs"
      variant="default"
    >
      <Typography
        color={isAnswerSelected ? 'invert' : 'main'}
        group="tight"
        thickness="regular"
        variant="caption1"
        whiteSpace="nowrap"
      >
        {answer.text}
      </Typography>
    </Button>
  )
}
